import type { FormikErrors } from "formik";

export { DEFAULT_FORM_SAVE_ERROR_TOAST_MESSAGE } from "./userFacingMessages";

/**
 * When to show inline field errors: existing persisted entity shows immediately on edit;
 * create flows defer until first submit or after an API attempt (liveValidationAfterSubmit).
 */
export function shouldShowFormFieldError<T extends object>(
    errors: FormikErrors<T>,
    field: keyof FormikErrors<T>,
    hasPersistedRecord: boolean,
    submitCount: number,
    liveValidationAfterSubmit: boolean
): boolean {
    return (
        (hasPersistedRecord || submitCount > 0 || liveValidationAfterSubmit) &&
        Boolean(errors[field])
    );
}
